import { Stack, Divider, Skeleton, Box, Group } from "@mantine/core";
import { CardPullRequest } from "../../../../../components/card-pull-request";
import { parseISO } from "date-fns";
import { LoaderInfiniteScroll } from "../../../../../components/loader-infinite-scroll";
import { PullRequestSize } from "@sweetr/graphql-types/frontend/graphql";
import { Fragment } from "react";
import { format } from "date-fns";
import { PageEmptyState } from "../../../../../components/page-empty-state";
import { parseNullableISO } from "../../../../../providers/date.provider";
import {
  IconCalendarFilled,
  IconRuler,
  IconStatusChange,
} from "@tabler/icons-react";
import { LoadableContent } from "../../../../../components/loadable-content/loadable-content";
import { FilterDate } from "../../../../../components/filter-date";
import { FilterMultiSelect } from "../../../../../components/filter-multi-select";
import { useTeamId } from "../use-team";
import { usePullRequestList } from "../../../../../providers/pull-request-list.provider";

export const TeamPullRequestsPage = () => {
  const teamId = useTeamId();

  const {
    pullRequests,
    isLoading,
    isEmpty,
    isFiltering,
    hasNextPage,
    infiniteScrollRef,
    isFirstOfYearMonth,
    filterValues,
    possibleStates,
    handleStateChange,
    handleSizeChange,
    handleCreatedAtChange,
    handleCompletedAtChange,
    resetFilters,
  } = usePullRequestList({ ownerIds: [teamId] });

  return (
    <>
      <Group gap={5}>
        <FilterDate
          label="Created"
          icon={IconCalendarFilled}
          onChange={handleCreatedAtChange}
          value={[
            parseNullableISO(filterValues.createdAtFrom) || null,
            parseNullableISO(filterValues.createdAtTo) || null,
          ]}
        />
        <FilterDate
          label="Completed"
          icon={IconCalendarFilled}
          onChange={handleCompletedAtChange}
          value={[
            parseNullableISO(filterValues.completedAtFrom) || null,
            parseNullableISO(filterValues.completedAtTo) || null,
          ]}
          clearable
        />
        <FilterMultiSelect
          width="target"
          label="State"
          icon={IconStatusChange}
          items={possibleStates}
          onChange={handleStateChange}
          value={filterValues.states}
          capitalize
        />
        <FilterMultiSelect
          width="target"
          label="Size"
          icon={IconRuler}
          items={Object.values(PullRequestSize).map((size) => ({
            label: size,
            value: size,
          }))}
          onChange={handleSizeChange}
          value={filterValues.sizes}
          capitalize
        />
      </Group>

      <LoadableContent
        mt="md"
        isLoading={isLoading}
        isEmpty={isEmpty}
        whenLoading={
          <Stack>
            <Skeleton height={20} />
            <Skeleton height={85} />
            <Skeleton height={85} />
            <Skeleton height={85} />
            <Skeleton height={85} />
            <Skeleton height={85} />
            <Skeleton height={85} />
          </Stack>
        }
        whenEmpty={
          <Box mt={80}>
            <PageEmptyState
              message="This team has no pull requests."
              isFiltering={isFiltering}
              onResetFilter={resetFilters}
            />
          </Box>
        }
        content={
          <Stack>
            {pullRequests?.map((pr) => {
              const createdAt = parseISO(pr.createdAt);

              return (
                <Fragment key={pr.id}>
                  {isFirstOfYearMonth(createdAt, pr.id) && (
                    <Divider
                      label={format(createdAt, "MMMM yyyy")}
                      labelPosition="left"
                    />
                  )}
                  <CardPullRequest pullRequest={pr} />
                </Fragment>
              );
            })}
            {hasNextPage && <LoaderInfiniteScroll ref={infiniteScrollRef} />}
          </Stack>
        }
      />
    </>
  );
};
